import { get } from "../shared/api-client";
import { JIVANDHARA_BASE, SILENT_LIST } from "./list-api-helpers";

/* ── API response types ── */

export type DashboardDailyTotal = {
  date: string;
  amount: string;
};

export type DashboardDailyCount = {
  date: string;
  count: number;
};

export type DashboardPaymentMode = {
  mode: string;
  amount: string;
  percent: number;
};

export type DashboardDonationByType = {
  donation_type_id: number | null;
  name: string;
  amount: string;
};

export type DashboardRecentDonor = {
  name: string;
  amount: string;
  date: string;
};

export type DashboardModuleCounts = {
  residents: number | null;
  donors: number | null;
  donations: number | null;
  adoption: number | null;
  tiffin_reqs: number | null;
  feedback: number | null;
  inquiries: number | null;
  visitors: number | null;
  donation_events: number | null;
  posts: number | null;
  punya_tithi: number | null;
  trustees: number | null;
  committee: number | null;
  gallery: number | null;
  Bhojan?: number | null;
  Gaushala?: number | null;
  Healthcare?: number | null;
  Tiffin?: number | null;
  tiffin?: number | null;
};

export type SeriesItemAmount = {
  day: number;
  date: string;
  amount: string;
};

export type SeriesItemCount = {
  day: number;
  date: string;
  count: number;
};

export type DonationSeries = {
  start: string;
  end: string;
  days: number;
  total: string | number;
  series: SeriesItemAmount[];
};

export type DonationCountSeries = {
  start: string;
  end: string;
  days: number;
  total: number;
  series: SeriesItemCount[];
};

export type DonationByScheme = {
  scheme_id: number | null;
  scheme__title?: string | null;
  scheme__name?: string | null;
  amount: number;
};

export type AnalyticsModuleData = {
  total_amount: string;
  financial_year_amount: string;
  last_15_days_donation_series: DonationSeries;
  last_15_days_donation_count_series: DonationCountSeries;
  payment_modes: DashboardPaymentMode[];
  donations_by_type?: DashboardDonationByType[];
  donations_by_scheme?: DonationByScheme[];
  recent_donors: DashboardRecentDonor[];
};

export type DashboardData = {
  total_donations: string;
  financial_year_donations: string;
  financial_year: {
    start: string;
    end: string;
  };
  total_donors: number;
  analytics: {
    simple: AnalyticsModuleData;
    bhojan: AnalyticsModuleData;
    gaushala: AnalyticsModuleData;
    healthcare: AnalyticsModuleData;
    tiffin: AnalyticsModuleData;
  };
  module_counts: DashboardModuleCounts;
};

type DashboardApiResponse = {
  success: boolean;
  message: string;
  data: DashboardData;
};

const BASE = `${JIVANDHARA_BASE}/dashboard`;

class DashboardService {
  fetch = async (): Promise<DashboardData> => {
    const response = await get<DashboardApiResponse>(`${BASE}/`, SILENT_LIST);
    return response.data;
  };
}

export const dashboardService = new DashboardService();
